import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const useStyles = makeStyles()((theme) => ({
  gridItems: {
    borderRadius: "15px",
    backgroundColor: "white",
    height: "27rem",
    width: "100%",
    color: theme.palette.primary.main,
  },
  flex: {
    padding: "15px",
    paddingBottom: 0,
  },
  parent: {
    overflow: "hidden",
  },
  headerText: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    display: "flex",
    lineHeight: "28px",
    marginBottom: "10px",
    // marginRight: 20,
  },
  pageText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "10%",
    marginBottom: "10px",
  },
  pagesContainer: {
    height: "80%",
  },
  profile: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    marginRight: 10,
    fontSize: "12px",
    fontWeight: 500,
  },
  //
  name: {
    fontWeight: 400,
    fontSize: "12px",
    fontFamily: "Poppins",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tooltip: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
  avatarAndText: {
    display: "flex",
    alignItems: "center",
  },
  figure: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: "#272525",
    paddingTop: 5,
  },
}));

export default useStyles;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
});
export { StyledTooltip };
